(function(algolia) {
  'use strict';

  if (!algolia.config.autocomplete_enabled) return;

  const autocomplete = algolia.externals.autocomplete;
  const cleanSearchTerms = window.theme.searchTerms.clean;

  algolia.searchClient.addAlgoliaAgent('Shopify Integration');

  // Retrieve the container from Shopify's config
  const containers = Array.from(document.querySelectorAll(algolia.config.input_selector));
  containers.forEach(container => {
    container.innerHTML = ''
    const containerClasses = container.classList;
    containerClasses.add('aa-MainContainer');
  });

  // Set plugins
  const { productsPlugin, collectionsPlugin, articlesPlugin, pagesPlugin, querySuggestionsPlugin } = algolia;
  const plugins = [
    algolia.config.index_products && productsPlugin,
    algolia.config.index_collections && collectionsPlugin,
    algolia.config.index_articles && articlesPlugin,
    algolia.config.index_pages && pagesPlugin,
    algolia.config.autocomplete_query_suggestions && querySuggestionsPlugin
  ];

  const cssFile = document.getElementById('template_algolia_autocomplete.css');
  //Set CSS variables
  document.documentElement.style.setProperty(`--aa-text-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.secondary)}`);
  document.documentElement.style.setProperty(`--aa-primary-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.main)}`);
  document.documentElement.style.setProperty(`--aa-muted-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.muted)}`);
  document.documentElement.style.setProperty(`--aa-highlight-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  //Link CSS
  algolia.appendStyle(cssFile.text);

  const autocompleteOptions = {
    openOnFocus: false,
    debug: algolia.config.autocomplete_debug,
    insights: algolia.config.analytics_enabled,
    plugins,
    render({ elements, render, html, state }, root) {
      const sourceIdsToExclude = ['products'];
      const hasLeftPanelResults = state.collections
              .filter(
                      ({ source }) => sourceIdsToExclude.indexOf(source.sourceId) === -1
              )
              .reduce((prev, curr) => prev + curr.items.length, 0) > 0;
      const [querySuggestionsPluginResults] = state.collections.filter(({source}) => source.sourceId === 'querySuggestionsPlugin');
      const displaySuggestions = algolia.config.autocomplete_query_suggestions && querySuggestionsPluginResults.items.length > 0;
      render(
              hasLeftPanelResults ?
              algolia.mainTemplate({ html, state }, elements, displaySuggestions)
              : algolia.mainProductsTemplate({ html, state }, elements),
              root
      );
    },
    renderNoResults({ render, html, state }, root) {
      render(
              algolia.noResultsTemplate({ html, state }),
              root
      )
    },
    // Popular-search suggestions come from what shoppers have typed, so drop any containing symbols.
    reshape({ sources }) {
      return sources.map(source => source.sourceId !== 'querySuggestionsPlugin' ? source : {
        ...source,
        getItems: () => source.getItems().filter(({ query }) => query === cleanSearchTerms(query))
      });
    },
    onSubmit({ state }) {
      window.location.href = `/search?q=${encodeURIComponent(cleanSearchTerms(state.query))}`;
    }
  }
  
  containers.forEach(container => {
    autocomplete({
      container,
      ...autocompleteOptions
    });
  });

  function focusAndOpenKeyboard(timeout) {
    if (!timeout) {
      timeout = 100;
    }
    // Align temp input element approx. to be where the input element is

    var __tempEl__ = document.createElement("input");
    __tempEl__.style.position = "absolute";
    __tempEl__.style.top = document.body.offsetTop + 7 + "px";
    __tempEl__.style.left = document.body.offsetLeft + "px";
    __tempEl__.style.height = 0;
    __tempEl__.style.opacity = 0;


    // var __tempEl__ = document.createElement("input");
    // __tempEl__.style.position = "absolute";
    // __tempEl__.style.top = 0;
    // __tempEl__.style.left = 0;
    // __tempEl__.style.height = '100px';
    // __tempEl__.style.width = '100px';
    // __tempEl__.style.background = '#000';
    // __tempEl__.style.zIndex = '99999999999';
    // __tempEl__.style.opacity = 1;
    // __tempEl__.style.color = "#fff";
    // Put this temp element as a child of the page <body> and focus on it
    document.body.appendChild(__tempEl__);
    __tempEl__.setAttribute('autofocus', 'autofocus');
    __tempEl__.value = 'asa';
    __tempEl__.focus();
    __tempEl__.click();

    // The keyboard is open. Now do a delayed focus on the target element
    setTimeout(function() {
      const el = document.querySelector('.aa-Form input');
      el.focus();
      el.click();
      // Remove the temp element
      document.body.removeChild(__tempEl__);
    }, timeout);
  }

  $('.aa-DetachedSearchButton').on('click', function () {
        focusAndOpenKeyboard(1000);
  })
})(window.algoliaShopify);
